import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Auth from '../../shared/Auth/Auth';

const Authorization = (WrappedComponent, isPrivate) => {
    class WithAuthorization extends React.Component {
    static propTypes = {
      isAuthorized: PropTypes.bool
    };

    componentWillMount() {
      this.isAuthorized()
    }

    isAuthorized = () => {
      Auth.currentAuthenticatedUser().then(user => {
      }).catch((err) => {
        localStorage.removeItem('user');
        localStorage.removeItem('userToken');
        return <Redirect to='/' />;
      })
    }

    render() {
      let isAuthorized = localStorage.getItem('user');
      if (!isAuthorized && isPrivate) {
          return <Redirect to='/' />;
      }
      if (isAuthorized && !isPrivate) {
        return <Redirect to='/admin/dashboard' />;
      }

      return <WrappedComponent {...this.props}/>;
    }
}

  const mapStateToProps = (state) => (
    {
      isAuthorized: Boolean(state.username)
    }
  );

  return connect(mapStateToProps)(WithAuthorization);
};

export default Authorization;
